/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../../components/Context/GloablContext';
import AdvancedSearchInputBox from '../../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import DateInput from '../../../../components/DateField';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { resetDeviceTemplateSearch, setDeviceTemplateSearch } from '../../../../redux/deviceTemplateSearchSlice';

export default function DeviceTemplateSearch({handleOnSubmit,emptyField,setEmptyField}) {
    const dispatch = useDispatch();
    const deviceTemplateSearch = useSelector(state => state.deviceTemplateSearchData); // Select deviceTemplateSearch from Redux
    const {isAdvancedSearchOpen,setIsAdvancedSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()

    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)
    const searchApplied = useSelector((state) => state.deviceTemplateSearchData.devicetempsearchApplied);
    
    /**
     * The function `handleOnChangeUserDetails` updates the state with a new value based on the
     * provided ID and value, with additional handling for specific cases.
     */
    const handleOnChangeUserDetails = (id, value) => {
        // Trim value if it's a string
        const updatedValue = typeof value === 'string' ? value : value;
        // Create an updated deviceTemplateSearch state
        const updatedState = {
            ...deviceTemplateSearch,
            [id]: updatedValue,
        };
        // Default handling for other fields (uncheck checkbox if input is cleared)
        if (updatedValue === '' && deviceTemplateSearch[`${id}_inverse`] === 'true') {
            updatedState[`${id}_inverse`] = '';
        }
        // Dispatch updated state to Redux
        dispatch(setDeviceTemplateSearch(updatedState));
    };

    // handleSelect checkbox functions
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;

        // Create an updated deviceSearch state
        const updatedState = { ...deviceTemplateSearch, [field]: checked ? 'true' : '' };

        // Dispatch the updated state
        dispatch(setDeviceTemplateSearch(updatedState));
    };
    
    // getting date format from redux state
    const dateformatSysconfig = useSelector(
        (state) => state?.systemConfigData?.globalVariables?.date_format
    );

    const [dateFormat, setDateFormat] = useState('dd/mm/yyyy');

    // Update date format from sysconfig
    useEffect(() => {
        if (dateformatSysconfig) {
            const format = dateformatSysconfig.split(',')[0].toLowerCase();
            setDateFormat(format === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy');
        }
    }, [dateformatSysconfig]);
    
    
    /**
     * The function `handleDateChange` validates and updates date fields based on input and field type
     * in a React component.
     */
    const handleDateChange = (newDate, fieldType) => {
        setEmptyField(false);
    
        // Validate input: only numbers, and apply limits
        const validatedDay = /^[0-9]*$/.test(newDate.day) && newDate.day <= 31 ? newDate.day : '';
        const validatedMonth = /^[0-9]*$/.test(newDate.month) && newDate.month <= 12 ? newDate.month : '';
        const validatedYear = /^[0-9]*$/.test(newDate.year) ? newDate.year : '';
        
        // Check if the date is fully cleared
        const isDateCleared = !validatedDay.trim() && !validatedMonth.trim() && !validatedYear.trim();
    
        // Determine the field to update based on fieldType
        const updatedSearch = {
            ...deviceTemplateSearch,
            [`${fieldType}_day`]: validatedDay,
            [`${fieldType}_month`]: validatedMonth,
            [`${fieldType}_year`]: validatedYear,
            [`${fieldType}_date_inverse`]: isDateCleared ? '' : deviceTemplateSearch[`${fieldType}_date_inverse`],
        };
    
        dispatch(setDeviceTemplateSearch(updatedSearch));
    };
    
    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {
            dispatch(resetDeviceTemplateSearch());
        }
    };

    /**
     * The function `isApplyButtonDisabled` checks if all values in the `deviceTemplateSearch` object
     * are considered empty based on their type.
     * @returns The function `isApplyButtonDisabled` is returning a boolean value. It checks each
     * key-value pair in the `deviceTemplateSearch` object and returns `true` if the value meets
     * certain conditions. The conditions are:
     * 1. If the key is 'match', it returns true (ignoring 'match').
     * 2. If the value is an empty array, it returns true.
     * 3. If the
     */
    const isApplyButtonDisabled = () => {
        return Object.entries(deviceTemplateSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /* The above code is using the `useEffect` hook in a React component to add an event listener for
    the "keydown" event on the window object. When a key is pressed, it checks if the key pressed is
    the "Escape" key, and if it is, it calls the `handleClearAll` function. The `useEffect` hook
    also includes a cleanup function that removes the event listener when the component unmounts or
    when the dependencies array is empty. */
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetDeviceTemplateSearch());
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)

    };

    /* The above code is a `useEffect` hook in a React component that listens for changes in the
    `isAdvancedSearchOpen` state variable. When `isAdvancedSearchOpen` changes, the code dispatches
    an action to reset the device template search state and then processes the search parameters
    from the URL query string. */
    useEffect(() => {
        dispatch(resetDeviceTemplateSearch())
        const params = Object.fromEntries(searchParams);
       
        if (params.search) {
            // Decode the search string to get individual fields
            const searchDecoded = decodeURIComponent(params.search);
       
            // Existing matches for user_id, first_name, last_name and other states
            const templateIdMatch = searchDecoded.match(/template_id=(ne:)?(.+?)(;|$)/);
            const tempNameMatch = searchDecoded.match(/template_name=(ne:)?(.+?)(;|$)/);
            const manufName = searchDecoded.match(/manufacturer_name=(ne:)?(.+?)(;|$)/);
            const model = searchDecoded.match(/model=(ne:)?(.+?)(;|$)/);
            const templateCreator = searchDecoded.match(/template_creator=(ne:)?(.+?)(;|$)/);
            const createdDateMatch = searchDecoded.match(/created_at=(ne:)?(\d+)(;|$)/);
            const modifiedDateMatch = searchDecoded.match(/updated_at=(ne:)?(\d+)(;|$)/);

       
            // Build the new state
            const updatedState = {};
       
            // handle template_id field
            if (templateIdMatch) {
                const isInverse = !!templateIdMatch[1]; 
                const tempIdValue = templateIdMatch[2]; 
       
                updatedState.template_id = tempIdValue === '__NULL__' ? '-' : tempIdValue;
                updatedState.template_id_inverse = isInverse ? 'true' : '';
            }
                
            // Handle template_name field
            if (tempNameMatch) {
                const isInverse = !!tempNameMatch[1];
                const tempNameValue = tempNameMatch[2];
                updatedState.template_name = tempNameValue === '__NULL__' ? '-' : tempNameValue;
                updatedState.template_name_inverse = isInverse ? 'true' : '';
            }

            // Handle manufacturer_name field
            if (manufName) {
                const isInverse = !!manufName[1];
                const manNameValue = manufName[2];
                updatedState.manufacturer_name = manNameValue === '__NULL__' ? '-' : manNameValue;
                updatedState.manufacturer_name_inverse = isInverse ? 'true' : '';
            }

            // Handle model field
            if (model) {
                const isInverse = !!model[1];
                const modelValue = model[2];
                updatedState.model = modelValue === '__NULL__' ? '-' : modelValue;
                updatedState.model_inverse = isInverse ? 'true' : '';
            }

            // Handle model field
            if (templateCreator) {
                const isInverse = !!templateCreator[1];
                const templateCreatorValue = templateCreator[2];
                updatedState.template_creator = templateCreatorValue === '__NULL__' ? '-' : templateCreatorValue;
                updatedState.template_creator_inverse = isInverse ? 'true' : '';
            }

            // Handle created date field
            if (createdDateMatch) {
                const isInverse = !!createdDateMatch[1]; 
                const epochTime = createdDateMatch[2]; 
                
                // Convert epoch time to a date
                const date = new Date(parseInt(epochTime, 10) * 1000); 
                
                // Use getDate(), getMonth(), and getFullYear() for local time
                const day = date.getDate().toString().padStart(2, '0'); // Ensure day is two digits
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure month is two digits
                const year = date.getFullYear().toString(); 
                
                // Update state with the correct date and inverse flag
                updatedState.created_day = day;
                updatedState.created_month = month;
                updatedState.created_year = year;
                updatedState.created_date_inverse = isInverse ? 'true' : ''; 
            }

            // Handle created date field
            if (modifiedDateMatch) {
                const isInverse = !!modifiedDateMatch[1]; 
                const epochTime = modifiedDateMatch[2]; 
                
                // Convert epoch time to a date
                const date = new Date(parseInt(epochTime, 10) * 1000); 
                
                // Use getDate(), getMonth(), and getFullYear() for local time
                const day = date.getDate().toString().padStart(2, '0'); // Ensure day is two digits
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure month is two digits
                const year = date.getFullYear().toString(); 

                // Update state with the correct date and inverse flag
                updatedState.updated_day = day;
                updatedState.updated_month = month;
                updatedState.updated_year = year;
                updatedState.updated_date_inverse = isInverse ? 'true' : ''; 
            }
                
            // Handle search_mode if applicable
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or' ? true : false;
            }
       
            // Dispatch the action to update Redux state
            setTimeout(() => {
                dispatch(setDeviceTemplateSearch(updatedState));
            }, 0);
        }
    }, [isAdvancedSearchOpen]);
    
  
    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => handleOnSubmit(e)} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={deviceTemplateSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${deviceTemplateSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!deviceTemplateSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!deviceTemplateSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Template ID"}
                                    placeholder={"Enter template ID"}
                                    id={"template_id"}
                                    data_testid={"template_id"}
                                    htmlFor={"template_id"}
                                    value={deviceTemplateSearch.template_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={15}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='template_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'template_id_inverse')}
                                        checked={deviceTemplateSearch.template_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceTemplateSearch?.template_id?.trim()===""}
                                    />
                                    <label htmlFor='template_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Template Name"}
                                    placeholder={"Enter template name"}
                                    id={"template_name"}
                                    data_testid={"template_name"}
                                    htmlFor={"template_name"}
                                    value={deviceTemplateSearch?.template_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={50}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='template_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'template_name_inverse')}
                                        checked={deviceTemplateSearch?.template_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceTemplateSearch?.template_name?.trim()===""}
                                    />
                                    <label htmlFor='template_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Manufacturer"}
                                    placeholder={"Enter manufacturer"}
                                    id={"manufacturer_name"}
                                    data_testid={"manufacturer_name"}
                                    htmlFor={"manufacturer_name"}
                                    value={deviceTemplateSearch?.manufacturer_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={50}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='manufacturer_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'manufacturer_name_inverse')}
                                        checked={deviceTemplateSearch?.manufacturer_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceTemplateSearch?.manufacturer_name?.trim()===""}
                                    />
                                    <label htmlFor='manufacturer_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Model"}
                                    placeholder={"Enter model"}
                                    id={"model"}
                                    data_testid={"model"}
                                    htmlFor={"model"}
                                    value={deviceTemplateSearch?.model}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={30}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='model_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'model_inverse')}
                                        checked={deviceTemplateSearch?.model_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceTemplateSearch?.model?.trim()===""}
                                    />
                                    <label htmlFor='model_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Template Creator"}
                                    placeholder={"Enter template creator"}
                                    id={"template_creator"}
                                    data_testid={"template_creator"}
                                    htmlFor={"template_creator"}
                                    value={deviceTemplateSearch?.template_creator}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={100}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='template_creator_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'template_creator_inverse')}
                                        checked={deviceTemplateSearch?.template_creator_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceTemplateSearch?.template_creator?.trim()===""}
                                    />
                                    <label htmlFor='template_creator_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInput
                                    labeltext={'Created Timestamp'}
                                    date={{
                                        day: deviceTemplateSearch.created_day,
                                        month: deviceTemplateSearch.created_month,
                                        year: deviceTemplateSearch.created_year,
                                    }}
                                    onDateChange={(newDate) => handleDateChange(newDate, 'created')}
                                    dateFormat={dateFormat}
                                    idPrefix="created"

                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='created_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'created_date_inverse')}
                                        checked={deviceTemplateSearch.created_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceTemplateSearch?.created_day?.trim()==="" || deviceTemplateSearch?.created_month?.trim()==="" || deviceTemplateSearch?.created_year?.trim()===""}
                                    />
                                    <label htmlFor='created_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInput
                                    labeltext={'Modified Timestamp'}
                                    date={{
                                        day: deviceTemplateSearch.updated_day,
                                        month: deviceTemplateSearch.updated_month,
                                        year: deviceTemplateSearch.updated_year,
                                    }}
                                    onDateChange={(newDate) => handleDateChange(newDate, 'updated')}
                                    dateFormat={dateFormat}
                                    idPrefix="updated"

                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='updated_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'updated_date_inverse')}
                                        checked={deviceTemplateSearch.updated_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceTemplateSearch?.updated_day?.trim()==="" || deviceTemplateSearch?.updated_month?.trim()==="" || deviceTemplateSearch?.updated_year?.trim()===""}
                                    />
                                    <label htmlFor='created_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        onClick={handleOnSubmit}
                        type='button'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
